import '@take-2/fd-modules/news/overview/app';
